//3rd Party Components
import React, { Fragment } from 'react';
import axios from 'axios';
import { useState } from 'react';
import { useSelector } from "react-redux";

//Actions
import { getUrlSelector, getSiteSelector } from '../../PortalStore/Selectors/EnvDataSelectors';

const KeepAlive = () => {

    let urlAEMHome = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlAEMKeepAlive = useSelector(state => getUrlSelector(state, "Portal - AEM Keep Alive URL"));

    let siteRedirect = useSelector(state => getSiteSelector(state, "Authentication/OpenIdConnect/B2C/RedirectUri"));

    let srcAEM = urlAEMHome + urlAEMKeepAlive;

    let standalone = useSelector(state => state.B2CSettings.items.standalone);

    const [srcPortal, setSrcPortal] = useState(siteRedirect + "/dummy");

    const keepPortalAlive = () => {
        if (!standalone) {
            setSrcPortal(siteRedirect + "/dummy"); //?clear first or add random number
        }
        setTimeout(keepPortalAlive, 300000);
    }

    const keepAEMAlive = () => {
        if (!standalone) {
            axios.post(srcAEM, null, null)
                .then(() => {
                    //debugger;
                })
                .catch(() => {
                    //debugger;
                });
            setTimeout(keepAEMAlive, 300000);
        }
    }

    setTimeout(keepPortalAlive, 300000);
    setTimeout(keepAEMAlive, 300000);
    
    return (
        <Fragment>
            <iframe
                id="keepAEMPortal"
                src={srcPortal}
                title="keepAlive"
                style={{ display: 'none' }} />
        </Fragment>
    )

}

export default KeepAlive;